import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
import { WalletModalReducer, WalletModalContext, initialState } from '.';
export const WalletModalProvider = (props) => {
    const { children } = props;
    const [modalState, modalDispatch] = useReducer(WalletModalReducer, initialState);
    return (_jsx(WalletModalContext.Provider, { value: { modalState: modalState, modalDispatch: modalDispatch }, children: children }));
};
WalletModalProvider.displayName = 'WalletModalProvider';
